// Mapping of internal screen access keys to human-friendly display names
export const SCREEN_ACCESS_MAP = {
  orders: 'Live Orders',
  analytics: 'Analytics',
  userManagement: 'User Management',
  menu: 'Menu',
  tables: 'Table Management',
  billGeneration: 'Bill Generation',
  orderHistoryForRestaurant: 'Order History',
  tableTracking: 'Table Tracking',
  quickServe: 'Quick Serve',
  restaurantSettings: 'Restaurant Settings',
} as const;

export type ScreenAccessKey = keyof typeof SCREEN_ACCESS_MAP;

export const SCREEN_ACCESS_OPTIONS: { key: ScreenAccessKey; label: string }[] =
  Object.entries(SCREEN_ACCESS_MAP).map(([k, v]) => ({ key: k as ScreenAccessKey, label: v }));

export function displayNameFor(key: ScreenAccessKey | string): string {
  return (SCREEN_ACCESS_MAP as Record<string, string>)[key] ?? String(key);
}

export function keys(): ScreenAccessKey[] {
  return Object.keys(SCREEN_ACCESS_MAP) as ScreenAccessKey[];
}

export default SCREEN_ACCESS_MAP;

// Centralized user roles used across the app's user management UI
export const USER_ROLES = [
  'Manager',
  'Dining Associate',
  'Owner',
  'Senior Manager',
  'Captian',
  'Senior Captian',
  'Chef',
] as const;

export type UserRole = typeof USER_ROLES[number];

export { USER_ROLES as USER_ROLES_CONST }; // named export for backward compatibility if needed
